module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "grid grid-pad box-size text-dark",
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('div', {
    staticClass: "col-1-1 box-size"
  }, [_c('div', {
    staticClass: "students-container"
  }, [_c('div', {
    staticClass: "students-container__header"
  }, [_c('div', {
    staticClass: "students-container__header__left"
  }, [_c('h1', [_vm._v(_vm._s(_vm.$t('vue2.students.students')))]), _vm._v(" "), _c('ChangeSchoolYear', {
    attrs: {
      "whiteTheme": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "students-container__header__right feide-import"
  }, [(_vm.isFeideImportActive) ? _c('div', {
    staticClass: "feide-import"
  }, [_c('img', {
    attrs: {
      "id": "feide-logo",
      "src": _vm.feideLogo
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "marg-1-right"
  }, [_c('span', {
    staticClass: "text-explainer"
  }, [_vm._v(_vm._s(_vm.$t('vue2.students.latest_updated')) + ":")]), _vm._v("\n              " + _vm._s(_vm.lastUpdateFromFeide))]), _vm._v(" "), _c('button', {
    staticClass: "marg-1-right bttn--is-import",
    staticStyle: {
      "width": "120px",
      "height": "34px"
    },
    on: {
      "click": _vm.updateFromFeide
    }
  }, [(!_vm.isImporting) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.students.import_students')))]) : _c('Loader', {
    staticStyle: {
      "margin": "0",
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "bg-color": "#f6f7f8"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('CreateStudents')], 1)]), _vm._v(" "), _c('div', {
    staticClass: "students"
  }, [_c('div', {
    staticClass: "students__col students__col1"
  }, [_c('div', {
    staticClass: "students__col__header"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.students.groups')))])]), _vm._v(" "), _c('div', {
    staticClass: "students__col__body",
    style: (_vm.bodyStyleObj)
  }, [(_vm.isLoading) ? _c('Loader', {
    attrs: {
      "bg-color": "#fff"
    }
  }) : _c('ul', [_c('li', {
    staticClass: "students__filters__filter",
    class: {
      'students__filters__filter--active': _vm.isTheActiveFilter('')
    },
    on: {
      "click": function($event) {
        return _vm.setTheActiveFilter('')
      }
    }
  }, [_c('div', [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.students.all')) + "\n                ")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "icon-user"
  }), _vm._v(" " + _vm._s(_vm.students.length))])]), _vm._v(" "), _c('li', {
    staticClass: "students__filters__filter",
    class: {
      'students__filters__filter--active': _vm.isTheActiveFilter('filter__activatedStudents')
    },
    on: {
      "click": function($event) {
        return _vm.setTheActiveFilter('filter__activatedStudents')
      }
    }
  }, [_c('div', [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.students.activated_schedules')) + "\n                ")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "icon-user"
  }), _vm._v(" " + _vm._s(_vm.studentsActivated.length))])]), _vm._v(" "), _c('li', {
    staticClass: "students__filters__filter",
    class: {
      'students__filters__filter--active': _vm.isTheActiveFilter('filter__students_without_groups')
    },
    on: {
      "click": function($event) {
        return _vm.setTheActiveFilter('filter__students_without_groups')
      }
    }
  }, [_c('div', [_vm._v("\n                  " + _vm._s(_vm.$t('vue2.students.without_group')) + "\n                ")]), _vm._v(" "), _c('div', [_c('span', {
    staticClass: "icon-user"
  }), _vm._v(" " + _vm._s(_vm.studentsWithoutKlasses.length))])]), _vm._v(" "), _c('li', {
    staticClass: "students__filters__filter students__filters__filter__title"
  }, [_vm._v(_vm._s(_vm.localActivatedSchoolYear.name) + "\n              ")]), _vm._v(" "), _vm._l((_vm.klassCalendars), function(klass) {
    return _c('li', {
      ref: "droppable_elements",
      refInFor: true,
      staticClass: "students__filters__filter",
      class: {
        'students__filters__filter--active': _vm.isTheActiveFilter(klass.id)
      },
      on: {
        "click": function($event) {
          return _vm.setTheActiveFilter(klass.id)
        },
        "dragover": function($event) {
          $event.preventDefault();
        },
        "dragenter": function($event) {
          $event.preventDefault();
          return _vm.dragEnter(klass, $event)
        },
        "dragleave": function($event) {
          $event.preventDefault();
          return _vm.dragLeave.apply(null, arguments)
        },
        "drop": function($event) {
          $event.preventDefault();
          return _vm.drop(klass, $event)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(klass.name))]), _vm._v(" "), _c('div', [_c('span', {
      staticClass: "icon-user"
    }), _vm._v(" " + _vm._s(klass.students ? klass.students.length : 0))])])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "students__col students__col2"
  }, [_c('div', {
    staticClass: "students__col__header students__col__header__students"
  }, [_c('h4', [_vm._v(_vm._s(_vm.$t('vue2.students.students')))])]), _vm._v(" "), _c('div', {
    ref: "students_col1_body",
    staticClass: "students__col__body",
    style: (_vm.bodyStyleObj)
  }, [_c('table', {
    staticClass: "students__table"
  }, [_c('thead', [_c('tr', {
    staticClass: "students__student students__student__header"
  }, [_c('th', [_c('span', {
    staticClass: "text-link",
    on: {
      "click": _vm.toggleAll
    }
  }, [(_vm.dragStudents.length < 1) ? [_vm._v(_vm._s(_vm.$t('vue2.tagging.select_all')))] : [_vm._v(_vm._s(_vm.$t('vue2.tagging.unselect_all')))]], 2)]), _vm._v(" "), _c('th', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.students.groups')) + " (" + _vm._s(_vm.localActivatedSchoolYear.name) + ")")]), _vm._v(" "), (_vm.isFeideActive) ? _c('th', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.students.feide')))]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.students.to_be_scheduled')))])])]), _vm._v(" "), (_vm.isLoading) ? _c('Loader', {
    attrs: {
      "bg-color": "#fff"
    }
  }) : _c('tbody', _vm._l((_vm.filteredStudents), function(student) {
    return _c('tr', {
      key: student.id,
      staticClass: "students__student",
      class: {
        'isSelected': student.v_isSelectedForDrag
      },
      attrs: {
        "draggable": "true"
      },
      on: {
        "dragstart": function($event) {
          $event.stopPropagation();
          return _vm.dragStart(student, $event)
        },
        "dragend": function($event) {
          $event.stopPropagation();
          return _vm.dragEnd(student, $event)
        },
        "dragover": function($event) {
          $event.stopPropagation();
        },
        "drop": function($event) {
          $event.preventDefault();
          return _vm.drop(_vm.slot, $event)
        },
        "click": function($event) {
          return _vm.setTheActiveStudent(student)
        }
      }
    }, [_c('td', [_c('div', {
      staticClass: "name-and-checkbox"
    }, [_c('div', {
      staticClass: "icon__bg-circle",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setStudentsSelectedForDrag(student)
        }
      }
    }, [_c('div', {
      staticClass: "d-checkbox",
      class: {
        'd-checkbox--active': false
      }
    })]), _vm._v("\n                    " + _vm._s(student.name) + "\n                  ")])]), _vm._v(" "), _c('td', _vm._l((student.v_klasses), function(klass, key) {
      return _c('span', [(key !== 0) ? _c('span', [_vm._v(", ")]) : _vm._e(), _vm._v("\n                " + _vm._s(klass.name))])
    }), 0), _vm._v(" "), (_vm.isFeideActive) ? _c('td', [_vm._v("\n                  " + _vm._s(student.custom_data && student.custom_data.feide ? student.custom_data['feide'] : '') + "\n                ")]) : _vm._e(), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "d-toggle",
      class: {
        'd-toggle--active': !student.archived_at
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.toggleStudentArchived(student)
        }
      }
    })])])
  }), 0)], 1)])])]), _vm._v(" "), (_vm.theActiveStudent) ? _c('DModal', {
    attrs: {
      "isBgOverlay": true,
      "showClose": false
    },
    on: {
      "close": _vm.closeModal
    }
  }, [_c('div', {
    staticClass: "doc-modal",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "doc-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.theActiveStudent.name))]), _vm._v(" "), _c('div', {
    staticClass: "doc-modal__close icon__bg-circle",
    on: {
      "click": _vm.closeModal
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "doc-modal__body"
  }, [_c('div', {
    staticClass: "d-input-group marg-1-bottom"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.students.name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editName),
      expression: "editName"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.editName)
    },
    on: {
      "keyup": function($event) {
        _vm.isEditStudentChanges = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editName = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.isFeideActive) ? _c('div', {
    staticClass: "d-input-group marg-1-bottom"
  }, [_c('label', {
    staticClass: "d-label"
  }, [_vm._v(_vm._s(_vm.$t('vue2.students.feide')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.editFeide),
      expression: "editFeide"
    }],
    staticClass: "d-input",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.editFeide)
    },
    on: {
      "keyup": function($event) {
        _vm.isEditStudentChanges = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.editFeide = $event.target.value
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-input-group"
  }, [_c('label', {
    staticClass: "d-label marg-05-bottom"
  }, [_vm._v(_vm._s(_vm.$t('vue2.students.groups')))]), _vm._v(" "), (_vm.getStudentRelations(_vm.theActiveStudent).length < 1) ? _c('div', {
    staticClass: "doc-modal__student__klasses__no-klasses"
  }, [_c('p', [_vm._v(_vm._s(_vm.$t('vue2.students.has_no_groups')))])]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "doc-modal__student__klasses"
  }, _vm._l((_vm.getStudentRelations(_vm.theActiveStudent)), function(klass, key) {
    return _c('li', {
      staticClass: "doc-modal__student__klasses__klass",
      class: {
        'klass--is-danger': _vm.isHoverOnKlass
      }
    }, [_c('div', [_vm._v(_vm._s(klass.name))]), _vm._v(" "), _c('div', {
      staticClass: "text-link",
      on: {
        "click": function($event) {
          return _vm.removeFromKlass(klass)
        },
        "mouseenter": function($event) {
          _vm.isHoverOnKlass = true
        },
        "mouseout": function($event) {
          _vm.isHoverOnKlass = false
        }
      }
    }, [_vm._v(_vm._s(_vm.$t('vue2.students.remove')) + "\n                  ")])])
  }), 0)])]), _vm._v(" "), _c('div', {
    staticClass: "doc-modal__footer"
  }, [_c('div', [_c('button', {
    staticClass: "hint--right bttn--warning",
    attrs: {
      "aria-label": _vm.$t('vue2.students.delete_student')
    },
    on: {
      "click": function($event) {
        _vm.isEditStudentConfirmation = true
      }
    }
  }, [_c('span', {
    staticClass: "icon-bin"
  })])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fadeInUp"
    }
  }, [(_vm.isEditStudentChanges) ? _c('div', [_c('button', {
    staticClass: "bttn submit-button",
    staticStyle: {
      "width": "120px"
    },
    on: {
      "click": _vm.submitModal
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.common.save')) + "\n                ")])]) : _vm._e()])], 1)])]) : _vm._e(), _vm._v(" "), (_vm.isEditStudentConfirmation) ? _c('ModalConfirmation', {
    on: {
      "close": _vm.closeModal,
      "confirm": _vm.deleteStudent
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    ref: "customdrag",
    staticClass: "d-custom-drag",
    staticStyle: {
      "display": "none"
    }
  }, [_c('span', {
    staticClass: "icon-user"
  }), _vm._v(" " + _vm._s(_vm.$t('vue2.common.add')) + " " + _vm._s(_vm.dragStudents.length) + "\n    "), (_vm.dragStudents.length === 1) ? [_vm._v(" " + _vm._s(_vm.$t('vue2.students.student')))] : [_vm._v(" " + _vm._s(_vm.$t('vue2.students.students')))]], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-c3632bf0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Students/Students.vue
// module id = 1740
// module chunks = 1